/* eslint import/prefer-default-export:0 */
export const COLOR_CODE_GREYOUT = '#9B9B9B !important';
